export const REGISTER_USER = "register_user"
export const REGISTER_USER_SUCCESSFUL = "register_user_successfull"
export const REGISTER_USER_FAILED = "register_user_failed"
export const GET_PASSWORD = "get_password"
export const GET_PASSWORD_SUCCESSFUL = "get_password_successfull"
export const GET_PASSWORD_FAILED = "get_password_failed"
export const CREATE_NEW_USER = "create_new_user"
export const CREATE_NEW_USER_SUCCESSFUL = "create_new_user_successfull"
export const CREATE_NEW_USER_FAILED = "create_new_user_failed"


